import Vue from "vue"

export const machinesEvent = new Vue()